import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from './Button';

const Header: React.FC = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isActive = (path: string) => location.pathname === path;

  const handleLogoClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // If already on home page, scroll to top instead of navigating
    if (location.pathname === '/') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between py-4">
          {/* Logo Area */}
          <Link to="/" className="flex items-center" onClick={handleLogoClick}>
            <div className="h-12 flex items-center">
              <span className="text-2xl font-bold text-primary font-serif">
                Advokatfirmaet Bruland
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-gray-700 hover:text-primary transition-colors pb-1 ${
                isActive('/') ? 'text-primary font-semibold border-b-2 border-accent' : ''
              }`}
            >
              Hjem
            </Link>
            <Link
              to="/om-oss"
              className={`text-gray-700 hover:text-primary transition-colors pb-1 ${
                isActive('/om-oss') ? 'text-primary font-semibold border-b-2 border-accent' : ''
              }`}
            >
              Om oss
            </Link>
            <Link
              to="/kontakt"
              className={`text-gray-700 hover:text-primary transition-colors pb-1 ${
                isActive('/kontakt') ? 'text-primary font-semibold border-b-2 border-accent' : ''
              }`}
            >
              Kontakt
            </Link>
            <a href="tel:+4722535322" aria-label="Ring Advokatfirmaet Bruland på 22 53 53 22">
              <Button size="sm" className="whitespace-nowrap gap-2">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                Ring 22 53 53 22
              </Button>
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700 hover:text-primary"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {mobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden pb-4 border-t border-gray-200 mt-2 pt-4">
            <nav className="flex flex-col space-y-4">
              <Link
                to="/"
                className={`text-gray-700 hover:text-primary transition-colors ${
                  isActive('/') ? 'text-primary font-semibold' : ''
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Hjem
              </Link>
              <Link
                to="/om-oss"
                className={`text-gray-700 hover:text-primary transition-colors ${
                  isActive('/om-oss') ? 'text-primary font-semibold' : ''
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Om oss
              </Link>
              <Link
                to="/kontakt"
                className={`text-gray-700 hover:text-primary transition-colors ${
                  isActive('/kontakt') ? 'text-primary font-semibold' : ''
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Kontakt
              </Link>
              <a href="tel:+4722535322" onClick={() => setMobileMenuOpen(false)} aria-label="Ring Advokatfirmaet Bruland på 22 53 53 22">
                <Button size="sm" fullWidth className="gap-2">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                  </svg>
                  Ring 22 53 53 22
                </Button>
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;

